import React, { Component, Fragment } from "react";
import { findDOMNode } from "react-dom";
import PropTypes from "prop-types";
import mobileDetect from "./mobile-detect";

const MENU_HEIGHT = 216;
const OPTION_HEIGHT = 54;

class Select extends Component {
	constructor(props) {
		super(props);

		this.state = {
			options: props.options,
			showOptions: false,
			selected: props.selected || { label: "Selecione", value: "" },
			filterText: "",
			dropUp: false,
			isMobile: mobileDetect()
		};

		// Option Bind
		this.toggleShowOptions = this.toggleShowOptions.bind(this);
		this.selectOptionAtIndex = this.selectOptionAtIndex.bind(this);
		this.handleChange = this.handleChange.bind(this);

		// DropUp Bind
		this.determineDropUp = this.determineDropUp.bind(this);

		// Click bind
		this.setOpenSection = this.setOpenSection.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
	}

	// Mount Control DropUp
	componentDidMount() {
		this.determineDropUp(this.props);
		window.addEventListener("resize", this.determineDropUp);
		window.addEventListener("scroll", this.determineDropUp);
		window.addEventListener("mousedown", this.handleClickOutside);
	}

	componentWillReceiveProps(nextProps) {
		this.determineDropUp(nextProps);
	}

	// Unmount Control DropUp
	componentWillUnmount() {
		window.removeEventListener("resize", this.determineDropUp);
		window.removeEventListener("scroll", this.determineDropUp);
		window.removeEventListener("mousedown", this.handleClickOutside);
	}

	determineDropUp(props = {}) {
		const options = props.options || this.props.options || [];
		const selected = props.selected || this.state.selected;
		const node = findDOMNode(this.selectInst);

		if (!node) return;

		const windowHeight = window.innerHeight;
		const menuHeight = Math.min(MENU_HEIGHT, options.length * OPTION_HEIGHT);
		const instOffsetBottomWithMenu = node.getBoundingClientRect().bottom + menuHeight;
		const instOffsetTopWithMenu = node.getBoundingClientRect().top + menuHeight;

		this.setState({
			options: options,
			selected: selected,
			dropUp: instOffsetBottomWithMenu >= windowHeight && instOffsetTopWithMenu > windowHeight + 100 // header
		});
	}

	setOpenSection(node) {
		this.openSection = node;
	}

	handleClickOutside(event) {
		if (
			this.openSection &&
			!this.selectInst.contains(event.target) &&
			!this.openSection.contains(event.target)
		) {
			this.setState({
				showOptions: false,
				filterText: ""
			});
			console.log(this.state.filterText);
		}
	}

	toggleShowOptions() {
		if (!this.props.disabled) {
			this.setState(prevState => ({ showOptions: !prevState.showOptions }));
		}
	}

	selectOptionAtIndex(option) {
		this.setState({
			selected: option,
			filterText: ""
		});

		this.props.onChange(option);
	}

	openOptions = () => {
		this.setState({
			showOptions: false
		});
	};

	handleChange(event) {
		this.setState({
			filterText: event.target.value
		});
	}

	filterKeyDown = e => {
		this.setState({
			filterText: e.target.value
		});
	};

	render() {
		const { disabled, errorMessage, hasSearch, optionsSize, dataActionFidelity, icon } = this.props;
		let dataAction = this.props.hasOwnProperty("data-action")
			? this.props["data-action"]
			: "select-offers";
		let mountedOptions = [];

		// TODO Optimize to mobile select
		// let TagSel = this.state.isMobile ? 'select' : 'div';
		// let TagOpt = this.state.isMobile ? 'option' : 'div';
		let TagSel = "div";
		let TagOpt = "div";

		if (!disabled && this.state.options) {
			this.state.options.forEach((option, index) => {
				if (
					option.label &&
					option.label.toLowerCase().indexOf(this.state.filterText.toLowerCase()) >= 0
				) {
					mountedOptions.push(
						<TagOpt
							key={index}
							value={option.value}
							className="select-component__option"
							onClick={() => {
								this.selectOptionAtIndex(option);
							}}
							data-action={
								dataActionFidelity ? dataAction + "-" + option.label.toLowerCase() : dataAction
							}
						>
							{option.highlight ? (
								<strong className="select-component__highlight">{option.highlight}</strong>
							) : null}
							<span>{option.label}</span>
						</TagOpt>
					);
				}
			});
		}

		let desktopComponent = (
			<Fragment>
				<TagSel
					className={`${
						this.state.showOptions
							? "form-group select-component select-component--show-options"
							: "form-group select-component"
					}
						${disabled ? "select-component--disabled" : ""}
						${errorMessage != undefined && errorMessage ? "select-component--error" : ""}
				`}
					ref={inst => (this.selectInst = inst)}
					onClick={this.toggleShowOptions}
				>
					{!!hasSearch ? (
						<div className="select-component__selected has-search">
							<i className="icon-search" />
							<input
								className="has-search"
								placeholder={this.state.selected.label}
								onChange={this.filterKeyDown}
								onClick={this.openOptions}
								value={this.state.filterText}
							/>
						</div>
					) : (
						<div className="select-component__selected">
							{this.state.selected.highlight ? (
								<strong className="select-component__highlight">
									{this.state.selected.highlight}
								</strong>
							) : null}
							<span>{this.state.selected.label}</span>
						</div>
					)}
					{icon ? (
						<i className="select-component__icon-down icon-arrow-down" />
					) : (
						<div className="select-component__caret caret--open" />
					)}

					{this.state.showOptions && (
						<div
							ref={this.setOpenSection}
							style={{ maxHeight: `${optionsSize ? OPTION_HEIGHT * optionsSize : MENU_HEIGHT}px` }}
							className={
								this.state.dropUp
									? "select-component__all-options open--dropup"
									: "select-component__all-options"
							}
						>
							{mountedOptions}
						</div>
					)}
				</TagSel>
				{errorMessage != undefined && errorMessage ? (
					<p className="text-right text-invalid">{errorMessage}</p>
				) : null}
			</Fragment>
		);

		return desktopComponent;
	}
}

Select.propTypes = {
	options: PropTypes.array,
	selected: PropTypes.object,
	onChange: PropTypes.func,
	disabled: PropTypes.bool,
	hasSearch: PropTypes.bool
};

export default Select;
